import { IGlobalLinks } from "@montana/models/generated/cms.interface";

export const getFindDealerUrl = (dealers?: string[], links?: IGlobalLinks): string | undefined => {
    if (!links?.storeLocatorPage) {
        return;
    }

    const dealerParams = dealers?.filter(q => !!q).sort((a,b) => a.localeCompare(b)).join('&dealer=');

    return `${links?.storeLocatorPage}${!!dealerParams ? `?dealer=${dealerParams}` : ''}`.toLowerCase();
}
